import React, { useEffect } from 'react'
import { useSearchParams } from 'react-router-dom'
import { useAppDispatch } from 'app/hooks'
import { setDisplayTheme, setExportMode } from 'features/ui/uiSlice'
import { setJWTToken } from 'utils/jwtUtil'
import { Theme } from 'features/ui/types'
import { useRetrievePreRequiredRequests } from '../view/hooks'
import DashboardMain from '../main'

const DashboardExport = () => {
  const dispatch = useAppDispatch()
  const [searchParams] = useSearchParams()
  const jwtToken = searchParams.get('jwtToken')
  const colorMode = searchParams.get('colorMode')
  const { pageConfigStatus } = useRetrievePreRequiredRequests()

  useEffect(() => {
    if (jwtToken) {
      setJWTToken(jwtToken)
    }
  }, [jwtToken])
  useEffect(() => {
    if (colorMode) {
      dispatch(setDisplayTheme(colorMode as Theme))
    }

    dispatch(setExportMode(true))
  }, [jwtToken, colorMode, dispatch])

  return pageConfigStatus === 'succeeded' ? <DashboardMain /> : undefined
}

export default DashboardExport
